import { BaseComponent, IStateBase } from 'components/BaseComponent';
import Grid from '@material-ui/core/Grid';
import React from 'react';
import { IUserAddressModel } from 'interfaces/IUserAddressModel';
import { paymentService } from 'services/PaymentService';
import FormControl from '@material-ui/core/FormControl';
import Translate from 'components/Translate';
import { ICountry } from 'interfaces/ICity';
import { getCountries } from 'services/LocationService';
import FieldText from 'components/Field/Text';
import FieldAutocomplete from 'components/Field/Autocomplete';

interface IState extends IStateBase {
  model: IUserAddressModel;
  countries: ICountry[];
}

export default class International extends BaseComponent<IState> {
  constructor(props: any) {
    super(props);
    this.state = { model: null, countries: [] };
  }

  componentDidMount() {
    this.bindModel(paymentService.getAddress());

    getCountries()
      .bindComponent(this)
      .subscribe(countries => this.setState({ countries }));
  }

  setStreet = (street: any) => {
    paymentService.setAddressData({ street });
  }

  setCity = (city: any) => {
    paymentService.setAddressData({ city });
  }

  setProvince = (province: any) => {
    paymentService.setAddressData({ province });
  }

  setPostalCode = (postalCode: any) => {
    paymentService.setAddressData({ postalCode });
  }

  setCountry = (country: any) => {
    paymentService.setAddressData({ country });
  }

  render() {

    if (!this.state.model) {
      return null;
    }

    const { model, countries } = this.state;

    model.country = model.country || 'none';

    return (
      <div>
        <Grid container spacing={24}>
          <Grid item xs={12}>
            <FieldText
              id='street'
              label={<Translate term='Endereço' />}
              validation='required'
              value={model.street}
              inputProps={{
                className: 'theme-input'
              }}
              InputLabelProps={{
                className: 'theme-label',
                id: 'label-international-street'
              }}
              onChange={this.setStreet}
            />
          </Grid>
        </Grid>

        <Grid container spacing={24}>
          <Grid item xs={12}>
            <FieldText
              id='city'
              label={<Translate term={'Cidade'} />}
              validation='required'
              value={model.city}
              inputProps={{
                className: 'field normal theme-input'
              }}
              InputLabelProps={{
                className: 'theme-label'
              }}
              onChange={this.setCity}
            />
          </Grid>
        </Grid>

        <Grid container spacing={24}>
          <Grid item xs={12}>
            <FieldText
              id='province'
              label={<Translate term={'Estado'} />}
              validation='required'
              value={model.province}
              inputProps={{
                className: 'theme-input'
              }}
              InputLabelProps={{
                className: 'theme-label'
              }}
              onChange={this.setProvince}
            />
          </Grid>
        </Grid>

        <Grid container spacing={24}>
          <Grid item xs={12}>
            <FieldText
              id='postalCode'
              label={<Translate term='CEP da Residência' />}
              validation='required'
              value={model.postalCode}
              inputProps={{
                className: 'theme-input'
              }}
              InputLabelProps={{
                className: 'theme-label',
                id: 'label-postal-code'
              }}
              onChange={this.setPostalCode}
            />
          </Grid>
        </Grid>

        <Grid container spacing={24}>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <FieldAutocomplete
                hideUnselectIcon
                hideSearchIcon
                id='find-country'
                label={<Translate term='País' />}
                value={model.country}
                placeholder='Search...'
                className='chk-userAddressInternational__country'
                inputProps={{
                  name: 'country',
                  id: 'country',
                  className: 'theme-input'
                }}
                InputLabelProps={{
                  className: 'theme-label'
                }}
                onChange={this.setCountry}
                options={countries.map(c => ({ label: c.country, value: c.id }))}
              />
            </FormControl>

          </Grid>
        </Grid>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/UserAddressForm/International/index.tsx